import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
`;

export const Label = styled.div`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  margin-right: 0.4rem;
  color: #181c24;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: 2rem;
  `}
`;

export const Value = styled.div`
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Bar = styled.div`
  height: 1.2rem;
  background-color: rgba(0, 0, 0, 0.05);
`;

export const BarValue = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.live.colors.primary};
`;
